import Text from '@/shared-components/text/components/Text';

import './styles/AuthSuccessText.css';

export default function AuthSuccessText({ className="", children }) {
  return (
    <>
      <div className={`auth-success-text__container ${className}`}>
        <Text className="auth-success-text__text font-size-small" paragraph justify>
          {children}
        </Text>
      </div>
    </>
  );
}
